/**
 * Public klasöründeki logo. Dosyayı değiştirdiğinizde ?v= değerini artırın (önbellek / eski siyah PNG).
 */
export const SITE_LOGO_SRC = '/logo-demaxtore.png?v=5';

/** Footer: tam marka + tagline görselleri için ayrı dosya. */
export const SITE_FOOTER_LOGO_SRC = '/logo-demaxtore-footer.png?v=1';

/** Homepage solution blocks — product line logos. */
export const LOGO_LIVE_SHIPMENT_TRACKING_SRC = '/logo-live-shipment-tracking.png?v=2';
export const LOGO_INSPECTION_SRC = '/logo-demaxtore-inspection.png?v=2';
/** FreightIQ block on homepage (MarketInsightsBanner). */
export const LOGO_FREIGHTIQ_SRC = '/logo-freightiq.png?v=1';

/** CommodityBid uygulaması — header CTA ve smart sourcing “Create a bid”. */
export const COMMODITY_BID_URL = 'https://commodity-bid.demaxtore.com/';

/** RFQ workspace — Solutions B2B Sourcing. */
export const RFQ_URL = 'https://rfq.demaxtore.com/';

/** Verified Manufacturers — Solutions B2B Sourcing. */
export const VERIFIED_MANUFACTURERS_URL = 'https://verifiedmanufacturers.demaxtore.com/';

/** Buyer portal — purchase order / account workflows. */
export const CUSTOMER_PORTAL_URL = 'https://customer.demaxtore.com/';

/** Buyer workspace — header account icon. */
export const WORKSPACE_URL = 'https://workspace.demaxtore.com/';

/** Buyer workspace sign-in (legacy). */
export const WORKSPACE_LOGIN_URL = 'https://workspace.demaxtore.com/login';

/** Digital freight — Solutions. */
export const FREIGHTIQ_URL = 'https://freight-iq.demaxtore.com/';
export const FREIGHTBOOKING_URL = 'https://freightbooking.demaxtore.com/';
export const ESTIMATED_CIF_URL = 'https://estimated-cif.demaxtore.com/';
export const CARRIER_URL = 'https://carrier.demaxtore.com/';
export const BULK_CONTAINER_URL = 'https://bulkcontainer.demaxtore.com/';
export const FULL_CONTAINER_URL = 'https://fullcontainer.demaxtore.com/';
export const SMART_CONTAINER_URL = 'https://smartcontainer.demaxtore.com/';

/** Import control tower — Solutions. */
export const INSPECTION_URL = 'https://inspection.demaxtore.com/';
export const LIVE_SHIPMENT_TRACKING_URL = 'https://liveshipmenttracking.demaxtore.com/';
export const DOCUMENT_CENTER_URL = 'https://documentcenter.demaxtore.com/';
export const EXCEPTION_HUB_URL = 'https://exceptionhub.demaxtore.com/';

/** Production site origin (no trailing slash). Override with REACT_APP_SITE_URL at build. */
export const SITE_ORIGIN =
  String(process.env.REACT_APP_SITE_URL || 'https://demaxtore.com')
    .trim()
    .replace(/\/+$/, '') || 'https://demaxtore.com';

export const SITE_TAGLINE =
  'B2B export platform connecting global buyers with verified Turkish suppliers';
